import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { GetLocationsResponse } from '../modal/location';

export interface GetLocationsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const getLocationsAPI = async (params?: GetLocationsParams) => {
  const response = await baseAPI.get<GetLocationsResponse>(
    `custom-form/studio/fields`,
    {
      params: {
        ...params,
        type: 'location',
      },
    },
  );
  return response.data;
};

export const getLocationsQueryOptions = (params?: GetLocationsParams) =>
  queryOptions({
    queryKey: [KEYS.LOCATIONS, params],
    queryFn: () => getLocationsAPI(params),
    placeholderData: keepPreviousData,
  });

export const useGetLocations = (params?: GetLocationsParams) => {
  return useQuery(getLocationsQueryOptions(params));
};
